<template>
    <Tabs
        :selected-user="selectedUser"
        :personal-team="userPersonalTeam"
        :billing-addresses="billingAddresses"
        tab-key="user-activity"
    >
        <DataTable
            class="mt-12"
            title="Activities"
            searchable
            :headers="headers"
            :items="activities"
        >
            <template #item-created_at="{ data }">
                <div v-if="data" class="flex justify-center p-6 text-gray-600">
                    {{ format(new Date(data as string), 'd. L. yyyy HH:mm') }}
                </div>
            </template>
        </DataTable>
    </Tabs>
</template>
<script lang="ts" setup>
import DataTable from '@/components/Atomic/DataTable/DataTable.vue';
import IDataTableHeader from '@/components/Atomic/DataTable/types/IDataTableHeader';
import IPaginationData from '@/components/Atomic/DataTable/types/IPaginationData';
import IActivity from '@/types/Members/IActivity';
import ICurrentTeam from '@/types/Members/ICurrentTeam';
import IUser from '@/types/Members/IUser';
import { format } from 'date-fns';

import Tabs from '../components/UserTabs.vue';
import IBillingAddress from '@/types/BillingAddresses/IBillingAddress';

defineProps<{
    selectedUser: IUser;
    activities: IPaginationData<IActivity>;
    userPersonalTeam: ICurrentTeam;
    billingAddresses: IBillingAddress[];    
}>();

const headers: IDataTableHeader[] = [
    {
        text: 'Description',
        id: 'description',
    },
    {
        text: 'Subject ID',
        id: 'subject_id',
    },
    {
        text: 'Subject Type',
        id: 'subject_type',
    },
    {
        text: 'Time',
        id: 'created_at',
    },
];
</script>
